import { c as _c } from "react/compiler-runtime";
import { type ChainId, ChainUtils } from '@morpho-org/blue-sdk';
import { safeParseNumber } from '@morpho-org/blue-sdk-viem';
import { InterfaceChainUtils, parseApiAsset, ZERO } from '@morpho-org/dapp-core';
import { useMemo } from 'react';
import { getVaultUrl } from '@/helpers/routing';
import { usePaginatedOffset } from '@/hooks/usePaginatedOffset';
import type { MarketSuppliersTableRow } from '../config';
import type { MarketSupplierItem } from '../config/queryKey';
import { toTableToken } from '../../tableToken';
export interface UseMarketSuppliersRowProps {
  items: readonly MarketSupplierItem[];
  chainId: ChainId;
  currentPage: number;
}
const useMarketSuppliersRow = t0 => {
  const $ = _c(8);
  const {
    items,
    chainId,
    currentPage
  } = t0;
  const {
    paginatedOffset,
    initOffset,
    setNextOffset
  } = usePaginatedOffset(ZERO);
  let t1;
  bb0: {
    const first = items[0];
    if (!first) {
      let t2;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = [];
        $[0] = t2;
      } else {
        t2 = $[0];
      }
      t1 = t2;
      break bb0;
    }
    initOffset(currentPage);
    let t2;
    if ($[1] !== chainId || $[2] !== currentPage || $[3] !== first.loanAsset || $[4] !== items || $[5] !== paginatedOffset || $[6] !== setNextOffset) {
      const asset = parseApiAsset(toTableToken(first.loanAsset, items.map(_temp), chainId));
      const identifier = InterfaceChainUtils.getIdentifierById(chainId);
      t2 = items.map(supplier => {
        const percentageShare = supplier.supplyShare === null ? ZERO : safeParseNumber(supplier.supplyShare);
        const currentOffset = paginatedOffset.current;
        setNextOffset(percentageShare, currentPage);
        const vault = supplier.vault && {
          address: supplier.vault.address,
          name: supplier.vault.name,
          logoUri: first.loanAsset.logoUri
        };
        return {
          isVaultV2: supplier.vault?.kind === "vaultV2",
          chainId,
          supplier: {
            address: supplier.userAddress,
            vault,
            url: vault ? getVaultUrl({
              identifier,
              vaultAddress: vault.address,
              vaultName: vault.name
            }) : ChainUtils.getExplorerAddressUrl(chainId, supplier.userAddress)
          },
          totalSupply: {
            amount: BigInt(supplier.supplyAssets),
            amountUsd: supplier.supplyAssetsUsd === null ? null : safeParseNumber(supplier.supplyAssetsUsd),
            asset
          },
          supplyShare: {
            value: percentageShare,
            percentageOffset: currentOffset
          }
        };
      });
      $[1] = chainId;
      $[2] = currentPage;
      $[3] = first.loanAsset;
      $[4] = items;
      $[5] = paginatedOffset;
      $[6] = setNextOffset;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    t1 = t2;
  }
  return t1;
};
export default useMarketSuppliersRow;
function _temp(item) {
  return {
    amount: item.supplyAssets,
    amountUsd: item.supplyAssetsUsd
  };
}